import { render, staticRenderFns } from "./BookDataTable.vue?vue&type=template&id=2a0b3684"
import script from "./BookDataTable.vue?vue&type=script&lang=js"
export * from "./BookDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports